var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFundsMission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 960,
    height: 117,
    viewBox: "0 0 960 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_5747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.931808 115.108H35.7385V31.5956L66.8272 3.62146L100.628 32.7625H139.869V115.132H100.242V58.4109H126.695H128.023",
    stroke: "#192830",
    strokeWidth: 2.358,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1818 70.9753H67.8256C70.4018 70.9753 72.8725 71.9987 74.6942 73.8204C76.5159 75.6421 77.5393 78.1128 77.5393 80.689V115.045H57.4761V80.689C57.4761 78.1142 58.4984 75.6447 60.3183 73.8233C62.1383 72.0018 64.6069 70.9775 67.1818 70.9753V70.9753Z",
    stroke: "#192830",
    strokeWidth: 2.358,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.124 70.9845H235.767C238.344 70.9845 240.814 72.0079 242.636 73.8296C244.458 75.6513 245.481 78.122 245.481 80.6982V115.086H225.394V80.6982C225.394 79.4212 225.646 78.1568 226.135 76.9772C226.624 75.7976 227.341 74.7261 228.245 73.8239C229.148 72.9217 230.221 72.2065 231.401 71.7193C232.582 71.2321 233.847 70.9824 235.124 70.9845V70.9845Z",
    stroke: "#192830",
    strokeWidth: 2.358,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.928 70.9845H438.571C439.847 70.9845 441.11 71.2358 442.289 71.7239C443.467 72.2121 444.538 72.9276 445.44 73.8296C446.342 74.7316 447.058 75.8024 447.546 76.9809C448.034 78.1594 448.285 79.4226 448.285 80.6982V115.086H428.214V80.6982C428.214 78.122 429.237 75.6512 431.059 73.8296C432.881 72.0079 435.351 70.9845 437.928 70.9845V70.9845Z",
    stroke: "#192830",
    strokeWidth: 2.358,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.79 115.422V44.658H208.766V114.996H195.431",
    stroke: "#192830",
    strokeWidth: 2.48677,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.781 105.812V115.14H260.593V3.25134H282.781V105.812Z",
    stroke: "#192830",
    strokeWidth: 2.48677,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.1 103.246C140.979 103.246 163.014 33.5359 172.1 33.5359C181.186 33.5359 203.221 103.246 172.1 103.246Z",
    stroke: "#192830",
    strokeWidth: 2.28557,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.454 116.281V48.6797",
    stroke: "#192830",
    strokeWidth: 2.28557,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.422 82.1368L172.454 86.3539",
    stroke: "#192830",
    strokeWidth: 2.28557,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.399 63.772L172.454 66.5968",
    stroke: "#192830",
    strokeWidth: 2.28557,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.454 75.8837L181.178 69.9927",
    stroke: "#192830",
    strokeWidth: 2.28557,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.781 3.25134L208.13 44.5043",
    stroke: "#192830",
    strokeWidth: 2.48677,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.965 115.075H398.138",
    stroke: "#192830",
    strokeWidth: 2.30167,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.3 115.069H512.473",
    stroke: "#192830",
    strokeWidth: 2.30167,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.283 116.066V50.7179H396.997V116.066",
    stroke: "#192830",
    strokeWidth: 2.30167,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.754 3.23621H366.736V50.5572H509.754V3.23621Z",
    stroke: "#192830",
    strokeWidth: 2.30167,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.564 11.3252H451.471V42.7599H484.564V11.3252Z",
    stroke: "#192830",
    strokeWidth: 2.30167,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.631 11.4132H451.617V29.8588H471.631V11.4132Z",
    stroke: "#192830",
    strokeWidth: 2.30167,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.018 11.3252H391.926V42.7599H425.018V11.3252Z",
    stroke: "#192830",
    strokeWidth: 2.30167,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.873 11.4132H404.858V29.8588H424.873V11.4132Z",
    stroke: "#192830",
    strokeWidth: 2.30167,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.334 51.4458V85.3431H481.225",
    stroke: "#192830",
    strokeWidth: 2.30167,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.414 51.4489V85.3381H396.079",
    stroke: "#192830",
    strokeWidth: 2.30167,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.839 103.051C335.275 103.051 343.735 92.1807 343.735 78.7712C343.735 65.3616 335.275 54.491 324.839 54.491C314.403 54.491 305.943 65.3616 305.943 78.7712C305.943 92.1807 314.403 103.051 324.839 103.051Z",
    stroke: "#192830",
    strokeWidth: 2.28557,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.134 66.4047V116.092",
    stroke: "#192830",
    strokeWidth: 2.28557,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.134 92.5665L334.811 88.3575",
    stroke: "#192830",
    strokeWidth: 2.28557,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.134 84.0538L314.869 75.7887",
    stroke: "#192830",
    strokeWidth: 2.28557,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.66 33.1416V116.187",
    stroke: "#192830",
    strokeWidth: 2.28557,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.21 64.9457L546.588 73.3234",
    stroke: "#192830",
    strokeWidth: 2.28557,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.062 64.8486L546.588 73.323",
    stroke: "#192830",
    strokeWidth: 2.28557,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.21 47.7334L546.588 56.1112",
    stroke: "#192830",
    strokeWidth: 2.28557,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.102 47.5969L546.588 56.1115",
    stroke: "#192830",
    strokeWidth: 2.28557,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.824 24.6189H543.498C537.373 24.6189 532.408 29.584 532.408 35.7088V75.9558C532.408 82.0805 537.373 87.0456 543.498 87.0456H549.824C555.948 87.0456 560.914 82.0805 560.914 75.9558V35.7088C560.914 29.584 555.948 24.6189 549.824 24.6189Z",
    stroke: "#192830",
    strokeWidth: 2.28557,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M778.042 67.5299H769.665C766.438 67.5299 763.822 70.1458 763.822 73.3726V84.1888C763.822 87.4157 766.438 90.0315 769.665 90.0315H778.042C781.269 90.0315 783.885 87.4157 783.885 84.1888V73.3726C783.885 70.1458 781.269 67.5299 778.042 67.5299Z",
    stroke: "#192830",
    strokeWidth: 2.28557,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M764.208 38.3402H748.419C742.294 38.3402 737.329 43.3053 737.329 49.4301V69.8312C737.329 75.956 742.294 80.9211 748.419 80.9211H764.208C770.333 80.9211 775.298 75.956 775.298 69.8312V49.4301C775.298 43.3053 770.333 38.3402 764.208 38.3402Z",
    stroke: "#192830",
    strokeWidth: 2.28557,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.613 49.9445V116.234",
    stroke: "#192830",
    strokeWidth: 2.28557,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.613 94.8208V116.236",
    stroke: "#192830",
    strokeWidth: 2.28557,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.905 68.0515H735.358C731.38 68.0515 728.155 71.2763 728.155 75.2543V86.5856C728.155 90.5636 731.38 93.7884 735.358 93.7884H743.905C747.883 93.7884 751.108 90.5636 751.108 86.5856V75.2543C751.108 71.2763 747.883 68.0515 743.905 68.0515Z",
    stroke: "#192830",
    strokeWidth: 2.28557,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.62 95.5729H769.81C770.772 95.5708 771.694 95.1877 772.375 94.5075C773.055 93.8273 773.438 92.9053 773.44 91.9434V83.6139",
    stroke: "#192830",
    strokeWidth: 2.28557,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.451 101.553H743.26C742.298 101.548 741.376 101.164 740.696 100.482C740.016 99.8006 739.633 98.8778 739.631 97.9151V84.8938",
    stroke: "#192830",
    strokeWidth: 2.28557,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.104 115.09H690.017V34.2663L673.431 54.8364H661.109V3.19373H631.485V54.8445H619.744L602.586 34.2421V115.09H578.483",
    stroke: "#192830",
    strokeWidth: 2.28557,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.105 13.048H637.432V25.168H655.105V13.048Z",
    stroke: "#192830",
    strokeWidth: 2.28557,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.888 32.5229H637.215V44.6429H654.888V32.5229Z",
    stroke: "#192830",
    strokeWidth: 2.28557,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.978 115.127H810.081V58.1329C810.083 43.0184 816.089 28.5237 826.777 17.8369C837.466 7.15014 851.961 1.14648 867.076 1.14648V1.14648C882.189 1.14648 896.684 7.1504 907.371 17.8374C918.058 28.5245 924.062 43.0192 924.062 58.1329V115.127H959.07",
    stroke: "#192830",
    strokeWidth: 2.28557,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.729 70.9845H646.373C648.949 70.9845 651.42 72.0079 653.242 73.8296C655.063 75.6512 656.087 78.122 656.087 80.6982V115.086H636.016V80.6982C636.016 78.122 637.039 75.6512 638.861 73.8296C640.682 72.0079 643.153 70.9845 645.729 70.9845V70.9845Z",
    stroke: "#192830",
    strokeWidth: 2.358,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M866.762 71.1968H867.406C869.982 71.1968 872.453 72.2202 874.275 74.0418C876.096 75.8635 877.12 78.3342 877.12 80.9105V115.266H857.057V80.9024C857.059 78.329 858.082 75.8615 859.902 74.0418C861.721 72.2221 864.189 71.1989 866.762 71.1968V71.1968Z",
    stroke: "#192830",
    strokeWidth: 2.358,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M887.896 60.8816C897.168 60.8816 904.684 53.3654 904.684 44.0939C904.684 34.8223 897.168 27.3062 887.896 27.3062C878.625 27.3062 871.108 34.8223 871.108 44.0939C871.108 53.3654 878.625 60.8816 887.896 60.8816Z",
    stroke: "#192830",
    strokeWidth: 2.358,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846.282 60.8816C855.553 60.8816 863.07 53.3654 863.07 44.0939C863.07 34.8223 855.553 27.3062 846.282 27.3062C837.01 27.3062 829.494 34.8223 829.494 44.0939C829.494 53.3654 837.01 60.8816 846.282 60.8816Z",
    stroke: "#192830",
    strokeWidth: 2.358,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_5747"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 958.138,
    height: 116.436,
    fill: "white",
    transform: "translate(0.931641)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFundsMission);
export default __webpack_public_path__ + "static/media/funds-mission.ba6fa6855c9a829be54c1c1cc3b03d42.svg";
export { ForwardRef as ReactComponent };